import React from "react";

import { Backup as B } from "../components/Backup";

export const Backup = () =>  {
  return <B download />;
};